import React, { memo } from 'react';
import moment from 'moment';
import { DayPickerSingleDateController, isInclusivelyAfterDay } from 'react-dates';
import phrases from './calendar-greek-phrases';
import ClosingIcon from '../../../assets/icons/closing-icon.svg';
import 'react-dates/lib/css/_datepicker.css';
import './calendar-wrapper.style.scss';
/**
 * A calendar component
 */
var CalendarWrapper = function (_a) {
    var date = _a.date, initialVisibleMonth = _a.initialVisibleMonth, isFocused = _a.isFocused, onDateChange = _a.onDateChange, onFocusChange = _a.onFocusChange, onClose = _a.onClose, onOutsideClick = _a.onOutsideClick, onNextMonthClick = _a.onNextMonthClick, onPrevMonthClick = _a.onPrevMonthClick, navNextBtn = _a.navNextBtn, navPrevBtn = _a.navPrevBtn;
    return (React.createElement(React.Fragment, null,
        React.createElement(DayPickerSingleDateController, { date: date, onDateChange: onDateChange, focused: isFocused, onFocusChange: function (_a) {
                var focused = _a.focused;
                return onFocusChange(focused);
            }, initialVisibleMonth: initialVisibleMonth, numberOfMonths: 1, isOutsideRange: function (day) { return isInclusivelyAfterDay(day, moment().add(1, 'days')); }, weekDayFormat: "ddd", renderNavPrevButton: navPrevBtn, renderNavNextButton: navNextBtn, onPrevMonthClick: onPrevMonthClick, onNextMonthClick: onNextMonthClick, phrases: phrases, onOutsideClick: onOutsideClick }),
        React.createElement("button", { type: "button", className: "tfm-calendar-close-btn", onClick: onClose, "aria-label": "\u03BA\u03BB\u03B5\u03AF\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B7\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF" },
            React.createElement(ClosingIcon, null))));
};
export default memo(CalendarWrapper);
